import { render, staticRenderFns } from "./OrderDetails.vue?vue&type=template&id=006e9a80&scoped=true&"
import script from "./OrderDetails.vue?vue&type=script&lang=js&"
export * from "./OrderDetails.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetails.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./OrderDetails.vue?vue&type=style&index=1&id=006e9a80&lang=scss&scoped=true&"
import style2 from "./OrderDetails.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006e9a80",
  null
  
)

export default component.exports